import React from 'react';
import { useTranslation } from 'react-i18next';

export const TaskModeSwitcher = ({ mode, onChange }) => {
  const { t } = useTranslation();

  return (
    <div className="inline-flex rounded-md shadow-sm mb-3" role="group">
      <button
        type="button"
        className={`px-3 py-1.5 text-sm font-medium rounded-l-lg ${
          mode === 'single' 
            ? 'bg-indigo-600 text-white' 
            : 'bg-white text-gray-700 hover:bg-gray-50'
        } border border-gray-200`}
        onClick={() => onChange('single')}
      >
        {t('taskMode.single')}
      </button>
      <button
        type="button"
        className={`px-3 py-1.5 text-sm font-medium rounded-r-lg ${
          mode === 'batch' 
            ? 'bg-indigo-600 text-white' 
            : 'bg-white text-gray-700 hover:bg-gray-50'
        } border border-gray-200`}
        onClick={() => onChange('batch')}
      >
        {t('taskMode.batch')}
      </button>
    </div>
  );
};